import { Pipe, PipeTransform } from "@angular/core";
import { filter, mergeMap, Observable } from "rxjs";
import { ApplicationService } from "../../../services/application.service";
import { MyUtils } from "../../../services/my-utils.service";

@Pipe({
  name: "translate",
})
export class TranslatePipe implements PipeTransform {
  constructor(private utils: MyUtils, private appService: ApplicationService) {}
  transform(value: string, ...args: unknown[]): Observable<string> {
    return this.appService.translationListSelect.pipe(
      filter((translation) => !translation.loader),
      mergeMap((_) => {
        let t = this.utils.traslatei18n(value);
        return [t];
      })
    );
  }
}
